export enum Languages {
  BR = 'pt-br',
  US = 'en-us',
  ES = 'es-es'
}
